<template lang="pug">
  div.modal-bg(@click="closeModal")
      div.change_heatmap_mode(@click.stop)
          div
            label.label-m(style="margin-left: 80px") ヒートマップは正常に表示できない場合
            span#modal-close(@click="closeModal")
          div
            p.mb-3.ml-3 サイトリードのヒートマップは、以下２種類の方法で表示をしています。  
            p.mb-0.ml-3 １．HTML方式
            p.mb-3.ml-3 WEBサイトのHTMLを自動で取得し、ヒートマップに反映
            p.mb-0.ml-3 ２．画像方式
            p.mb-3.ml-3 WEBサイトのキャプチャを自動で取得し、ヒートマップに反映

            p.mb-0.ml-3 HTML方式の場合、WEBサイトの仕様次第で、
            p.mb-0.ml-3 以下のような表示エラーが出る場合がございます。
            p.mb-0.ml-3 その場合、画像方式に切り替えをしてください。
            p.mb-3.ml-3 ※画像方式の表示には、１〜２時間程度の時間かかります。
          div.d-flex.align-items-center
            img.mr-0.display-image(src="/img/heatmap_error.png" alt="heatmapError") 
            div
              p.mb-0.ml-0 ・Webサイトが表示されない
              p.mb-0.ml-0 ・Webサイトが表示さるが、
              p.mb-0.ml-0 　Webサイト内の画像サイズがおかしい
          div.d-flex.justify-content-between
            form(ref="changeHeatmapMode" :action="action_url" method="POST" @submit.prevent="changeHeatmapMode")
              <input type="hidden" name="_method" value="PUT">    
              button.btn.btn-success.btn-sm(style="margin-left: 200px" type='submit') {{image_mode?"HTML方式に切り替える":"画像方式に切り替える" }}
  </template>

  <script>
export default {
    props: {
      action_url: {type: String, default: "" },
      image_mode: {type: Boolean, default: true },
    },
    methods: {
        closeModal() {
            this.$emit('close-modal'); // 親コンポーネントへイベントを通知
        },
        async changeHeatmapMode() {
          this.$emit('close-modal');
          this.$refs.changeHeatmapMode.submit()
          },
    },
}
</script>
<style lang="scss" scoped>
.change_heatmap_mode {
  position: fixed;
  top: 32px;
  left: 50%;
  transform: translateX(-50%);
  background-color: white;
  z-index: 99999;
  border-radius: 4px;
  width: 610px;
}

.change_heatmap_mode div:first-child {
  border-bottom: solid 1px #000;
  padding: 8px 16px;
}

.change_heatmap_mode div:last-child {
  padding: 8px 16px;
}

.change_heatmap_mode div:last-child a {
  border: none;
  background-color: #28A745;
  color: white;
  border-radius: 4px;
  padding: 4px 16px;
  width: fit-content;
  margin: auto;
}
</style>
